module.exports = __webpack_public_path__ + "static/media/rr-favicon.6a456234.svg";